export default __webpack_public_path__ + "cfcfdebe0308112c3f7ade16078e21a9.png";